import { render, staticRenderFns } from "./ebooks.vue?vue&type=template&id=67848aa9&scoped=true&"
import script from "./ebooks.vue?vue&type=script&lang=js&"
export * from "./ebooks.vue?vue&type=script&lang=js&"
import style0 from "./ebooks.vue?vue&type=style&index=0&id=67848aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67848aa9",
  null
  
)

export default component.exports